var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',{staticClass:"headline"},[_c('h1',[_vm._v(_vm._s(_vm.headLine))])])
}
var staticRenderFns = []

export { render, staticRenderFns }